import { Pagination } from 'types/model/common'
import { Product } from 'types/model/product'

export enum ORDER_STATUS {
  INIT = 'init',
  OPEN = 'open',
  COLLECTING = 'collecting',
  COLLECTED = 'collected',
  DELIVERING = 'delivering',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
}

export interface OrderPart {
  labels: { [key: string]: string }[]
  crc: string
  placeId: string
  id: string
  visibleId: string
  storeId: string
  status: ORDER_STATUS
  deliveryId: number
  products: Product[]
  deliveryMethod: {
    notes: { message: string }[]
    type: string
    service: {
      type: string
      address: {
        street: string
        building: string
        apartment: string
        postcode: string
        postalArea: string
        city: string
        state: string
        additionalInformation: string
        latitude: number
        longitude: number
      }
      code: string
      deliverySlot: {
        startTime: string
        endTime: string
        deliveryDate: string
        attributes: string[]
      }
      price: { currency: string }
    }
  }
}

export interface Order {
  masterId: string
  id: string
  parts: OrderPart[]
  visibleId: string
  customerAddress: { name: string; email: string; phone: string }
  createdAt: Date
  payment: { type: string; status: string }
  totalPrice: { totalPriceVat: number }
  capturedPrice: { totalPriceVat: number }
  placeId: string
  customerInfo: {
    customerId: string
    loyaltyCardId: string
  }
  status: string
}

export interface OrdersResponse {
  data: Order[]
  meta: {
    pagination: Pagination
  }
}
export interface OrderResponse {
  data: Order
}

export interface OrderEvent {
  id: string
  message: string
  createdAt: string
  sender: number
  eventData?: string
  details: {
    actor: string
    action: string
    orderStatus: string
  }
  data: {
    ean: number
    sku: string
    quantity: number
    newEan?: number
    amount?: number
    productId?: number
    message?: string
  }
  type: number
  fasUserId: string
}
export interface OrderEventResponse {
  data: OrderEvent[]
}
